import { render, staticRenderFns } from "./OAdminList.vue?vue&type=template&id=03da031a&scoped=true&"
import script from "./OAdminList.vue?vue&type=script&lang=ts&"
export * from "./OAdminList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03da031a",
  null
  
)

export default component.exports